import axios from "axios";
// require('dotenv').config();

const API_URL = process.env.REACT_APP_API_URL;

const Axios = axios.create({
  baseURL: API_URL, 
  timeout: 600000, // 10 minutes timeout
});

// Function to set the token in the request headers
const parseStoredToken = (raw) => {
  if (raw == null || raw === "") return null;
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    return parsed || null;
  } catch {
    return typeof raw === "string" ? raw : null;
  }
};

const setAuthToken = (explicitToken) => {
  const token =
    explicitToken != null && explicitToken !== ""
      ? parseStoredToken(explicitToken)
      : parseStoredToken(localStorage.getItem("access_token_AS"));

  if (token) {
    Axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return true;
  }

  delete Axios.defaults.headers.common["Authorization"];
  if (explicitToken == null || explicitToken === "") {
    localStorage.removeItem("access_token_AS");
  }
  return false;
};

export { Axios, setAuthToken };
